import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/good_company'
    },
    {
      path: '/good_company',
      name: 'good_company',
      component: () => import('@/components/Good_company')
    },
    {
      path: '/good_jobs',
      name: 'good_jobs',
      component: resolve => void (require(['@/components/Good_jobs'], resolve))
    },
    {
      path: '/job_detail/:job_id',
      name: 'job_detail',
      component: () => import('@/components/Job_detail')
    },
    {
      path: '/company_detail/:company_id',
      name: 'company_detail',
      component: () => import('@/components/Company_detail')
    },
    {
      path: '/company_sub/:company_id',
      name: 'company_sub',
      component: () => import('@/components/Company_sub')
    },
    {
      path: '/tweet_detail/:tweet_id',
      name: 'tweet_detail',
      component: () => import('@/components/Tweet_detail')
    },
    {
      path: '/contact_editor',
      name: 'contact_editor',
      component: resolve => void (require(['@/components/Contact_editor'], resolve))
    },
    {
      path: '/erp_qrcode',
      name: 'erp_qrcode',
      component: resolve => void (require(['@/components/Erp_qrcode'], resolve))
    },
    {
      path: '/erp_consultation',
      name: 'erp_consultation',
      component: resolve => void (require(['@/components/Erp_consultation'], resolve))
    },
    {
      path: '/hr_qrcode',
      name: 'hr_qrcode',
      component: resolve => void (require(['@/components/Hr_qrcode'], resolve))
    },
    {
      path: '/city_list',
      name: 'city_list',
      component: resolve => void (require(['@/components/City_list'], resolve))
    },
    {
      path: '/city_qrcode',
      name: 'city_qrcode',
      component: resolve => void (require(['@/components/City_qrcode'], resolve))
    },
    {
      path: '/recently',
      name: 'recently',
      component: resolve => void (require(['@/components/Recently'], resolve))
    },
    {
      path: '/registration',
      name: 'registration',
      component: resolve => void (require(['@/components/Registration'], resolve))
    },
    {
      path: '/match_fast',
      name: 'match_fast',
      component: resolve => void (require(['@/components/Match_fast'], resolve))
    },
    {
      path: '/match_success',
      name: 'match_success',
      component: resolve => void (require(['@/components/Match_success'], resolve))
    },
    {
      path: '/match_fail',
      name: 'match_fail',
      component: resolve => void (require(['@/components/Match_fail'], resolve))
    },
    {
      path: '/person_center',
      name: 'person_center',
      component: resolve => void (require(['@/components/Person_center'], resolve))
    },
    {
      path: '/user_basic',
      name: 'user_basic',
      component: resolve => void (require(['@/components/user/UserBasic'], resolve))
    },
    {
      path: '/user_password',
      name: 'user_password',
      component: resolve => void (require(['@/components/user/PasswordEdit'], resolve))
    },
    {
      path: '/forget_password',
      name: 'forget_password',
      component: resolve => void (require(['@/components/user/PasswordForget'], resolve))
    },
    {
      path: '/resume_view',
      name: 'resume_view',
      component: resolve => void (require(['@/components/Resume_view'], resolve))
    },
    {
      path: '/resume_list',
      name: 'resume_list',
      component: resolve => void (require(['@/components/Resume_list'], resolve))
    },
    {
      path: '/resume_edit',
      name: 'resume_edit',
      component: resolve => void (require(['@/components/ResumeEdit'], resolve))
    },
    {
      path: '/form',
      name: 'form',
      component: resolve => void (require(['@/components/Form'], resolve))
    },
    {
      path: '/resume/edu',
      name: 'edu',
      component: resolve => void (require(['@/components/resume/Educational'], resolve))
    },
    {
      path: '/resume/job_intention',
      name: 'job_intention',
      component: resolve => void (require(['@/components/resume/JobIntention'], resolve))
    },
    {
      path: '/resume/skills',
      name: 'skills',
      component: resolve => void (require(['@/components/resume/Skills'], resolve))
    },
    {
      path: '/resume/signs',
      name: 'signs',
      component: resolve => void (require(['@/components/resume/Signs'], resolve))
    },
    {
      path: '/resume/self',
      name: 'self',
      component: resolve => void (require(['@/components/resume/Self'], resolve))
    },
    {
      path: '/resume/worked',
      name: 'worked',
      component: resolve => void (require(['@/components/resume/Worked'], resolve))
    },
    {
      path: '/resume/experienced',
      name: 'experienced',
      component: resolve => void (require(['@/components/resume/Experienced'], resolve))
    },
    {
      path: '/resume/exp_other',
      name: 'exp_other',
      component: resolve => void (require(['@/components/resume/ExpOther'], resolve))
    },
    {
      path: '/resume/certificate',
      name: 'certificate',
      component: resolve => void (require(['@/components/resume/Certificate'], resolve))
    },
    {
      path: '/resume/title',
      name: 'resume_title',
      component: resolve => void (require(['@/components/resume/ResumeTitle'], resolve))
    },
    {
      path: '/resume/basic',
      name: 'basic',
      component: resolve => void (require(['@/components/resume/BasicInfo'], resolve))
    },
    {
      path: '/login_openid',
      name: 'login_openid',
      component: resolve => void (require(['@/components/LoginOpenid'], resolve))
    },
    {
      path: '/login',
      name: 'login',
      component: resolve => void (require(['@/components/Login'], resolve))
    },
    {
      path: '/bind_phone',
      name: 'bind_phone',
      component: resolve => void (require(['@/components/BindPhone'], resolve))
    },
    {
      path: '/perfect_info',
      name: 'perfect_info',
      component: resolve => void (require(['@/components/PerfectInfo'], resolve))
    },
    {
      path: '/collect_job',
      name: 'collect_job',
      component: resolve => void (require(['@/components/CollectJob'], resolve))
    },
    {
      path: '/resume_send',
      name: 'resume_send',
      component: resolve => void (require(['@/components/Resume_send'], resolve))
    },
    {
      path: '/send_success',
      name: 'send_success',
      component: resolve => void (require(['@/components/Resume_send_success'], resolve))
    },
    {
      path: '/format_resume',
      name: 'format_resume',
      component: resolve => void (require(['@/components/FormateResume'], resolve))
    },
    {
      path: '/get_openid',
      name: 'get_openid',
      component: resolve => void (require(['@/components/GetOpenid'], resolve))
    },
    {
      path: '/user_agreement',
      name: 'user_agreement',
      component: resolve => void (require(['@/components/UserAgree'], resolve))
    },
  ]
})

const history = window.sessionStorage
// history.clear()
let historyCount = history.getItem('count') * 1 || 0
history.setItem('/', 0)
let isPush = false
let isTouchStart = false
let endTime = Date.now()
let methods = ['push', 'go', 'replace', 'forward', 'back']

document.addEventListener('touchend', () => {
  isTouchStart = false
  endTime = Date.now()
})
document.addEventListener('touchstart', () => {
  isTouchStart = true
})

methods.forEach(key => {
  let method = router[key].bind(router)
  router[key] = function (...args) {
    isPush = true
    method.apply(null, args)
  }
})

router.beforeEach(function (to, from, next) {

  const toIndex = history.getItem(to.path)
  const fromIndex = history.getItem(from.path)
  let direction

  if (toIndex) {
    if (!fromIndex || parseInt(toIndex, 10) > parseInt(fromIndex, 10) || (toIndex === '0' && fromIndex === '0')) {
      direction = 'forward'
    } else {
      direction = 'reverse'
    }
  } else {
    ++historyCount
    history.setItem('count', historyCount)
    to.path !== '/' && history.setItem(to.path, historyCount)
    direction = 'forward'
  }

  // 判断是否是ios左滑返回 或者 右滑前进
  if (toIndex && toIndex !== '0' && !isPush && (((Date.now() - endTime) < 377) || isTouchStart)) {
    store.commit('updateDirection', {direction: ''})
  } else {
    store.commit('updateDirection', {direction: direction})
  }
  isTouchStart = false

  if (/\/http/.test(to.path)) {
    let url = to.path.split('http')[1]
    window.location.href = `http${url}`
  } else {
    if (_hmt) {
      if (to.path) {
          _hmt.push(['_trackPageview', '/#' + to.fullPath]);
      }
    }
    next()
  }
})

router.afterEach(function (to) {
  isPush = false
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js